//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { Activity } from '../../models/common/activity'
import {default as commonModule, LoggerService} from './../common/common.module'
import {default as apiModule, Api, LocalDictionaryFactory} from './../api/api.module'
import {MenuItem} from '../common/sidebar-menu/common.sidebar-menu.directive'
import { UserSession } from '../../helpers/user-session'

//#region Asset Imports

import './kpi.scss';
import * as TEMPLATE from './kpi.tpl.html'

//#endregion

import {KPIController} from './kpi.controller'

let moduleName = 'simax.kpi';
let module = angular.module(moduleName, [commonModule, apiModule ]);

module.controller('KPIController', ['$scope', '$state', '$q', 'api', 'logger', 'localDictionary', ($scope, $state: StateService, $q: ng.IQService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory) => new KPIController($scope, $state, $q, api, logger, localDictionary)]);

module.config(['$stateProvider', 'userSessionProvider', ($stateProvider: StateProvider, userSessionProvider: UserSession) => {
    userSessionProvider.getLoggedOperatorAsync().then(loggedOperator => {
        if (loggedOperator.hasPermission(Activity.PERFORMANCES_LPG_KPI_LIST)) {
            MenuItem.addMenuItem(window['config']['ICONS']['KPI'], 'kpi', 'KPI', 'kpi', 1);
            $stateProvider.state('kpi', {
                url: "/kpi",
                controller: 'KPIController',
                template: TEMPLATE,
                params: { ids: null }
            })
        }
    })
}]);

export default moduleName